import { sql } from "drizzle-orm";
import { check, sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// payments — ใบจ่ายเงิน (Pay)
// ============================================================================
export const payments = sqliteTable("accounting_payments", {
  id: text("id").primaryKey(), // ULID
  paymentNo: text("payment_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  paymentType: text("payment_type", {
    enum: ["pay"],
  }).notNull().default("pay"),
  partyType: text("party_type", {
    enum: ["customer", "supplier"],
  }).notNull(),
  partyId: text("party_id").notNull(),
  paymentDate: text("payment_date").notNull(),
  paymentMethod: text("payment_method").notNull(),
  amount: real("amount").notNull(),
  paymentPurpose: text("payment_purpose", {
    enum: ["invoice_payment", "advance", "on_account"],
  })
    .notNull()
    .default("invoice_payment"),
  advanceAccountId: text("advance_account_id"),
  whtTypeId: text("wht_type_id"),
  whtRate: real("wht_rate").notNull().default(0),
  whtAmount: real("wht_amount").notNull().default(0),
  whtTaxPeriod: text("wht_tax_period"), // YYYY-MM; payment date is the tax event
  vatAtPaymentAmount: real("vat_at_payment_amount").notNull().default(0),
  vatAtPaymentAccountId: text("vat_at_payment_account_id"),
  vatAtPaymentPeriod: text("vat_at_payment_period"), // YYYY-MM; payment date is the tax event
  referenceNo: text("reference_no"),
  bankAccountId: text("bank_account_id"), // Legacy FK → accounts (cash/bank GL account)
  paymentChannel: text("payment_channel", {
    enum: ["cash", "bank_transfer", "cheque", "other"],
  }).notNull().default("cash"),
  bankAccountMasterId: text("bank_account_master_id"), // FK → accounting_bank_accounts
  bankTransferReference: text("bank_transfer_reference"),
  chequeId: text("cheque_id"), // FK → accounting_cheques
  chequeNo: text("cheque_no"),
  chequeDate: text("cheque_date"),
  chequeBankName: text("cheque_bank_name"),
  receiptUrl: text("receipt_url"),
  docStatus: integer("doc_status").notNull().default(0), // 0=Draft, 1=Submitted, 2=Cancelled
  status: text("status", {
    enum: ["draft", "submitted", "cancelled"],
  })
    .notNull()
    .default("draft"),
  currencyCode: text("currency_code").default("THB"),
  exchangeRate: real("exchange_rate").default(1),
  remarks: text("remarks"),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("pay_company_status_idx").on(table.companyId, table.status, table.paymentDate),
  companyPartyIdx: index("pay_company_party_idx").on(table.companyId, table.partyType, table.partyId),
  companyBranchIdx: index("pay_company_branch_idx").on(table.companyId, table.branchId),
  companyBankMasterIdx: index("pay_company_bank_master_idx").on(table.companyId, table.bankAccountMasterId),
  companyChequeIdx: index("pay_company_cheque_idx").on(table.companyId, table.chequeId),
  ownerCheck: check("accounting_payments_owner_chk", sql`${table.paymentType} = 'pay'`),
}));

// Type exports
export type Payment = typeof payments.$inferSelect;
export type NewPayment = typeof payments.$inferInsert;
